import * as Yup from "yup";

export const EditTableSchema = Yup.object().shape({
  date_format: Yup.string().required("Date Format is required"),
});
